import React, { useState } from "react";
import toast from "react-hot-toast";
import { changePassword } from "../../api/userRequest";
import "./changepassword.css";

function ResetPasswordEmail() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await changePassword({ email });
      toast.success(data.message);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <main className="auth-layout">
      <form className="card" onSubmit={handleSubmit}>
        <h1 className="heading">Reset Password</h1>

        <div className="input-group">
          <label>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="primary-btn">
          Submit
        </button>
      </form>
    </main>
  );
}

export default ResetPasswordEmail;
